import encrypt from "../../../plugin/lib/encrypt";

export default {
  name: 'Business',
  data() {
    return {
      telNumber: '',
      toastTel:'',
      toastShow: false,
      toastText: '',
      isDisabled:false
    }
  },
  beforeCreate:function(){
    if(!sessionStorage.getItem('userName')){
      this.$router.replace({name: 'Login'})
    }
  },
  created:function(){
    this.banScale()
  },
  methods:{
    toast (str) {
      let v = this
      v.toastText = str
      v.toastShow = true
      setTimeout(function(){
        v.toastShow = false
      }, 2000)
    },
    backtoManage(){
      this.$router.push({name:'Manage'})
    },
    banScale(){
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })//禁止缩放
    },
    //ios 12+ 微信中白板bug
    checkWxScroll(){
      var ua = navigator.userAgent.toLowerCase();
      var u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(ua.match(/MicroMessenger/i) == 'micromessenger'&&!!u){
        var osVersion  =  navigator.userAgent.match(/iPhone\sOS\s([\d\_]+)/i);
        var  osArr = osVersion.length>=1? osVersion[1].split('_'):[];
        var newOS = osArr.length>=2 && (osArr[0]>11)
        if(newOS){
          this.temporaryRepair();
        }
      }
    },
    temporaryRepair(){
      var currentPosition,timer;
      var speed=1;
      timer=setInterval(function(){
        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition-=speed;
        window.scrollTo(0,0);
        clearInterval(timer);
      },1);
    },
    onAdd(){
      this.telNumber=this.telNumber.trim();
      if(this.isDisabled)
        return;
      var pattern = new RegExp(/^\d{11}$/)
      var self_w=this;
      var params={
        userPhone:this.telNumber,
        circleId:sessionStorage.getItem('circleId')
      }
      if(!this.telNumber)
        this.toastTel='请输入手机号'
      else if (!pattern.test(this.telNumber))
        this.toastTel = '请输入11位手机号'
      else{
        this.isDisabled=true;
        this.$http.get('/circle/v1/circle/addBusinessOperator',{params:encrypt(params)})
          .then(function (response) {
              this.toastTel=response.body.msg
              if(response.body.msg=="已添加"){
                this.toast('添加成功 3s后返回')
                setTimeout(function () {
                  self_w.$router.push({name:'Manage'})
                  this.isDisabled=false;
                },3000)
              }
              else{
                this.isDisabled=false;
              }
          })
          .catch(function (response){
              alert('error')
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/page/scene/business/bs.js